export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/menu-86a00bd55b1b3d2e812afb03c28832de.png";